import { useEffect, useState } from 'react';
export const useMode = () => {
    const [mode, setMode] = useState(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    useEffect(() => {
        const listener = (e) => setMode(e.matches ? "dark" : "light");
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', listener);
        return window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', listener);
    }, []);
    return mode;
};
